<template>
    <div data-app>
        <v-dialog v-model="dialog" persistent max-width="350">
            <v-card>
                <v-card-title class="headline">
                    Emin misiniz?
                </v-card-title>
                <v-card-text
                    >Silmek istediğiniz kayıt kalıcı olarak silinecektir. Bu
                    kaydı silmek istediğinize emin misiniz?</v-card-text
                >
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="text-danger" text @click="dialog = false">
                        Hayır
                    </v-btn>
                    <v-btn class="text-success" text @click="deleteBlock">
                        Evet
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <div class="col-md-12">   
            <KTCard v-bind:title="title">
                <template v-slot:body>
                    <form ref="form" id="form" novalidate="novalidate" lazy-validation class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed">
                        <div class="m-portlet__body">

                            <div class="form-group m-form__group row">
                                <label class="col-lg-3 col-form-label">Tribün:</label>
                                <div class="col-lg-9">
                                    <select class="form-control" v-model="block.stand_id" :class="{view: !isEditing}" :disabled="!isEditing">
                                        <option v-for="stand in stands" :value="stand.id" :key="stand.id"> 
                                            {{ stand.name }} 
                                        </option>
                                    </select>
                                    <div v-if="errors.stand_id" :errors="errors">
                                        <b-badge v-for="error in errors.stand_id" class="mr-1" :key="error.stand_id" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-3 col-form-label">Blok İsmi:</label>
                                <div class="col-lg-9">
                                    <input type="text" class="form-control form-control-sm m-input" :class="{view: !isEditing}" :disabled="!isEditing" v-model="block.name">
                                    <div v-if="errors.name" :errors="errors">
                                        <b-badge v-for="error in errors.name" class="mr-1" :key="error.name" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-3 col-form-label">Kategori:</label>
                                <div class="col-lg-9">
                                    <input type="text" class="form-control form-control-sm m-input" :class="{view: !isEditing}" :disabled="!isEditing" v-model="block.category">
                                    <div v-if="errors.category" :errors="errors">
                                        <b-badge v-for="error in errors.category" class="mr-1" :key="error.category" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-3 col-form-label">Aktif mi?:</label>
                                <div class="col-lg-9">
                                    <b-form-checkbox value="1" switch size="lg" :class="{view: !isEditing}" :disabled="!isEditing" v-model="block.is_active"></b-form-checkbox>
                                    <div v-if="errors.is_active" :errors="errors">
                                        <b-badge v-for="error in errors.is_active" class="mr-1" :key="error.is_active" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <template v-if="timeStamps">
                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">Ekleyen:</label>
                                    <div class="col-lg-9">
                                        {{ block.user_created_name }}
                                    </div>
                                </div>
                                
                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">Ekleme Tarihi:</label>
                                    <div class="col-lg-9">
                                        <span>{{ block.created_at | formatDateTime }}</span>
                                    </div>
                                </div>

                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">Güncelleyen:</label>
                                    <div class="col-lg-9">
                                        {{ block.user_updated_name }}
                                    </div>
                                </div>

                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">Güncelleme Tarihi:</label>
                                    <div class="col-lg-9">
                                        <span>{{ block.updated_at | formatDateTime }}</span>
                                    </div>
                                </div>

                        </template>
                          
                        </div>
                        <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
                            <div class="m-form__actions m-form__actions--solid">
                                <div class="row">
                                    <div class="col-lg-3"></div>
                                    <div class="col-lg-9">
                                        <!-- EKLEME BUTONLARI -->
                                        <template v-if="addButtons">
                                            <b-button
                                                v-if="hasPermission('blocks.create')"
                                                size="sm"
                                                variant="success"
                                                :disabled="isDisabled"
                                                @click="saveBlockAndGoBack()"
                                            >
                                            <i class="la la-save"></i>
                                            <i class="la la-rotate-left"></i>
                                                Kaydet ve Geri Dön
                                            </b-button>
                                            
                                            <b-button
                                                v-if="hasPermission('blocks.create')"
                                                size="sm"
                                                variant="primary"
                                                :disabled="isDisabled"
                                                @click="saveBlockAndAddNew()"
                                            >
                                            <i class="la la-save"></i>
                                                Kaydet ve Yeni Ekle
                                            </b-button>
                                        </template>

                                        <!-- GÜNCELLEME BUTONLARI -->
                                        <template v-if="editButtons">  
                                            <b-button
                                                v-if="hasPermission('blocks.update')"
                                                size="sm"
                                                variant="success"
                                                :disabled="isDisabled"
                                                @click="updateBlockAndGoBack()"
                                            >
                                            <i class="la la-save"></i>
                                            <i class="la la-rotate-left"></i>
                                                Güncelle ve Geri Dön
                                            </b-button>

                                            <b-button
                                                v-if="hasPermission('blocks.update')"
                                                size="sm"
                                                variant="primary"
                                                :disabled="isDisabled"
                                                @click="updateBlock()"
                                            >
                                            <i class="la la-save"></i>
                                                Güncelle
                                            </b-button>

                                            <b-button
                                                v-if="hasPermission('blocks.delete')"
                                                size="sm"
                                                variant="danger"
                                                :disabled="isDisabled"
                                                @click="dialog = true"
                                            >
                                            <i class="la la-trash"></i>
                                                Sil
                                            </b-button>

                                            
                                            
                                        </template>

                                        <!-- GÖRÜNTÜLEME BUTONLARI -->
                                        <template v-if="viewButtons">
                                            <b-button
                                                v-if="hasPermission('blocks.delete')"
                                                size="sm"
                                                variant="danger"
                                                :disabled="isDisabled"
                                                @click="dialog = true"
                                            >
                                            <i class="la la-trash"></i>
                                                Sil
                                            </b-button>

                                            <b-button
                                                v-if="hasPermission('blocks.update')"
                                                size="sm"
                                                variant="success"
                                                :disabled="isDisabled"
                                                @click="changeFormToEditing()"
                                            >
                                            <i class="la la-edit"></i>
                                                Güncellemeyi Aktif Et
                                            </b-button>
 
                                        </template>   
                                        <template>
                                            <b-button 
                                                size="sm" 
                                                @click="$router.go(-1)">
                                                <i class="la la-undo"></i>
                                                İptal
                                            </b-button> 
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </template>
            </KTCard>
        </div>
        <div class="text-center">
            <b-spinner
                variant="primary"
                type="grow"
                label="Spinning"
                v-if="loading"
            ></b-spinner>
        </div>
    
    </div>



    
</template>

<script>

import KTCard from "@/view/content/Card.vue";
import { mapGetters} from 'vuex';
import { mapState} from 'vuex';
import { GET_BLOCK_DATA } from "@/core/services/store/blocks.module";
import { CREATE_BLOCK } from "@/core/services/store/blocks.module";
import { UPDATE_BLOCK } from "@/core/services/store/blocks.module";
import { DELETE_BLOCK } from "@/core/services/store/blocks.module";
import { ALL_STANDS } from "@/core/services/store/stands.module";

export default {
    name: "blocks-form",
    
    data() {
        return {
            dialog: false,
            block:{
                user_created_name: "",
                user_updated_name: ""
            },
            formType: "",
            title: "",
            addButtons: false,
            editButtons: false,
            viewButtons: false,
            timeStamps: false,
            isEditing: true,
            blocks: {},
            options: [
                { value: '1', text: 'Evet', selected: true },
                { value: '0', text: 'Hayır' },
            ],

            value: [],
            stands: []         
        };
    },
   
    methods: {
        saveBlockAndGoBack() {
            const data = this.block;
            const goBack = true;
            this.$store.dispatch(CREATE_BLOCK, {data, goBack})
        },

        saveBlockAndAddNew() {
            const data =  this.block;
            const goBack = false;
            this.$store.dispatch(CREATE_BLOCK, {data, goBack})
        },

        updateBlockAndGoBack() {
            const data = this.block;
            const goBack = true;
            this.$store.dispatch(UPDATE_BLOCK, { data, goBack })
        },

        updateBlock() {
            const data = this.block;
            const goBack = false;
            this.$store.dispatch(UPDATE_BLOCK, { data, goBack })
        },

        deleteBlock() {
            var itemToDelete = this.block.id;
            this.$store.dispatch(DELETE_BLOCK, { itemToDelete })
            .then(() => { 
                this.$router.go(-1);
                this.dialog = false;
            })
        },

        changeFormToAdding(){
            this.title = "Blok: Yeni Kayıt Formu"
            
            this.addButtons = true;
            this.editButtons = false;
            this.viewButtons = false;
            this.timeStamps = false;
            this.isEditing = true;
        },

        changeFormToEditing(){
            this.title = "Blok: Güncelleme Formu"
            this.addButtons = false;
            this.editButtons = true;
            this.viewButtons = false;
            this.timeStamps = true;
            this.isEditing = true;
        },

        changeFormToViewing(){
            this.title = "Blok: Detaylar"
            this.addButtons = false;
            this.editButtons = false;
            this.viewButtons = true;
            this.timeStamps = true;
            this.isEditing = false;
        },

        hasPermission(permission) {
            return this.currentUserMenu.permissions.some(function(el) {
                return el.name === permission;
            }); 
        },

        getAllStands() {
            this.$store.dispatch(ALL_STANDS)
            .then(( response ) => {
                this.stands = response.data;
            })
        }
        

    },


    components: {
        KTCard,
        //Multiselect
    },

    created() {
        this.isEditing = !this.isEditing;
        this.formType = this.$route.params.formType;
        this.$store.dispatch('getUserMenu');
        this.$store.dispatch('createBlockForm');
        this.block.is_active = 1;
        if (this.formType != "add") {
            var id = this.$route.params.id;
            this.$store.dispatch(GET_BLOCK_DATA, { id })
            .then(( response ) => {
                this.block = response.data;
                this.block.user_created_name = response.data.user_created_name[0].name;
                this.block.user_updated_name = response.data.user_updated_name[0].name;
            })
        }

        this.getAllStands();
    },

    mounted() {
        
        if(this.formType === "add"){
            this.changeFormToAdding();
        }
        if(this.formType === "edit"){
            this.changeFormToEditing();
        }
        if(this.formType === "view"){
            this.changeFormToViewing();
        }
    },

    computed: {
        ...mapGetters(["currentUserMenu"]),

        ...mapState({
            loading: state => state.blocks.loading,
            row: state => state.blocks.row,
            errors: state => state.blocks.errors,
            isDisabled: state => state.blocks.isDisabled,
            //user: state => state.users.user_data
        })
    }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.view {
    border-color: transparent;
    background-color: initial;
    color: initial
}
</style>
